import { useTranslation } from "react-i18next";

import { ScreenView } from "../ScreenView/ScreenView";

import { useStyles } from "./ScreenViewPage.style";

function getUrlParams() {
    const params = new URLSearchParams(window.location.search);

    return { sessionId: params.get("sessionId") ?? "" };
}

export const ScreenViewPage = () => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);
    const params = getUrlParams();

    if (!params.sessionId) {
        return <div className={classes.container}>{t("pages:screenViewPage.noSessionId")}</div>;
    }

    return (
        <div className={classes.container}>
            <ScreenView sessionId={params.sessionId} />
        </div>
    );
};
